import React from 'react';
import OrivonLogo from './OrivonLogo';
import { LOGO_BETA_WRAPPER_STYLE } from './logoBetaWrapperStyle';
import { LOGO_HEIGHT_NAV_COMPACT, LOGO_HEIGHT_NAV_WIDE } from './logoMarkSizes';

function resolveHeight(height, compact) {
  if (height != null) return height;
  if (compact === true) return LOGO_HEIGHT_NAV_COMPACT;
  if (compact === false) return LOGO_HEIGHT_NAV_WIDE;
  return LOGO_HEIGHT_NAV_WIDE;
}

/**
 * Site wordmark — raster includes “Beta” in `public/images/orivonai-logo.png` (transparent).
 * Wrapper keeps nav/footer tap targets and `LOGO_BETA_WRAPPER_STYLE` alignment.
 */
export default function LogoWithBeta({
  height,
  compact,
  logoClassName,
  alt = 'OrivonAI',
  style,
  /** If true, render only the logo (no wrapper div). Parent must supply flex row layout. */
  unwrapped = false,
}) {
  const h = resolveHeight(height, compact);
  const inner = <OrivonLogo height={h} className={logoClassName} alt={alt} />;
  if (unwrapped) return inner;
  return <div style={{ ...LOGO_BETA_WRAPPER_STYLE, minWidth: 0, gap: 0, ...style }}>{inner}</div>;
}
